(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function closeHoverDropdown(details) {
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');

    details.querySelectorAll('details[open]').forEach((nestedDetails) => {
      nestedDetails.removeAttribute('open');
      nestedDetails.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  function openHoverDropdown(header, details) {
    const summary = details.querySelector(':scope > summary');
    const isTopLevel = details.parentElement?.tagName === 'HEADER-MENU';

    if (isTopLevel) {
      header
        .querySelectorAll('.header__inline-menu > ul > li > header-menu > details[open]')
        .forEach((openDetails) => {
          if (openDetails !== details) closeHoverDropdown(openDetails);
        });
    } else {
      const siblingList = details.parentElement?.parentElement;

      siblingList?.querySelectorAll(':scope > li > details[open]').forEach((openDetails) => {
        if (openDetails !== details) closeHoverDropdown(openDetails);
      });
    }

    details.setAttribute('open', '');
    summary?.setAttribute('aria-expanded', 'true');
  }

  function setupHeaderHoverMenus(root = document) {
    if (!desktopHoverQuery.matches) return;

    root.querySelectorAll('.header[data-dropdown-hover-enabled="true"]').forEach((header) => {
      header.querySelectorAll('.header__inline-menu details').forEach((details) => {
        if (details.dataset.hoverDropdownReady === 'true') return;

        details.dataset.hoverDropdownReady = 'true';
        let closeTimer;

        details.addEventListener('mouseenter', () => {
          window.clearTimeout(closeTimer);
          openHoverDropdown(header, details);
        });

        details.addEventListener('mouseleave', () => {
          closeTimer = window.setTimeout(() => {
            if (!details.matches(':hover') && !details.contains(document.activeElement)) {
              closeHoverDropdown(details);
            }
          }, 180);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupHeaderHoverMenus());
  } else {
    setupHeaderHoverMenus();
  }

  document.addEventListener('shopify:section:load', (event) => {
    setupHeaderHoverMenus(event.target);
  });

  desktopHoverQuery.addEventListener('change', (event) => {
    if (event.matches) {
      setupHeaderHoverMenus();
      return;
    }

    document
      .querySelectorAll('.header[data-dropdown-hover-enabled="true"] .header__inline-menu details[open]')
      .forEach((details) => closeHoverDropdown(details));
  });

  } catch(e) { console.error(e); }
})();
})();
